export const security = {
  'if-you-donot-have-patranomic': 'Otasining ismi boʻlmasa, chiziqcha qoʻying',
  citizenship: 'Fuqarolik',
  'email-results': 'Tekshiruv natijalari asosida <strong>{userEmail}</strong> email manzilingizga xabar yuboriladi',
  'store-manager': 'Doʻkon direktori',
  'security-questionnaire': 'Ichki anketa',
  'acceptable-formats': 'Mos formatlar - .jpeg, .jpg, .png, .pdf',
  'download-file-before-sending': 'Yuborishdan oldin fayl(lar)ni yuklang',
  'field-too-long': 'Maksimum 255 belgi',
};
